// extracted by mini-css-extract-plugin
export default {"main":"styles_main__JqSDp","header":"styles_header__dX9uL","headerBox":"styles_headerBox__ZCTpF"};